import React, { useState, useEffect } from 'react';
import { IMaskInput } from 'react-imask';

interface CpfInputProps {
  onChange?: (value: string, isValid: boolean) => void;
  id?: string;
  className?: string;
  required?: boolean;
  placeholder?: string;
  defaultValue?: string;
  disabled?: boolean;
}

function isValidCpf(cpf: string): boolean {
  cpf = cpf.replace(/[^\d]+/g, '');
  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;
  let soma = 0;
  for (let i = 0; i < 9; i++) soma += parseInt(cpf[i]) * (10 - i);
  let resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf[9])) return false;
  soma = 0;
  for (let i = 0; i < 10; i++) soma += parseInt(cpf[i]) * (11 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  return resto === parseInt(cpf[10]);
}

const CpfInput: React.FC<CpfInputProps> = ({
  onChange,
  id = 'cpf',
  className = 'form-control',
  required = false,
  placeholder = '',
  defaultValue = '',
  disabled = false,
}) => {
  const [value, setValue] = useState(defaultValue);
  const [valid, setValid] = useState<boolean | null>(null);

  const handleAccept = (val: string) => {
    setValue(val);
    const isValid = isValidCpf(val);
    setValid(isValid);
    onChange?.(val, isValid);
  };

  useEffect(() => {
    if (defaultValue) {
      // Aplica a máscara via IMask formatador manual
      const masked = defaultValue.replace(/\D/g, '')
        .replace(/^(\d{3})(\d)/, '$1.$2')
        .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})\.(\d{3})(\d{2})$/, '.$1.$2-$3');

      setValue(masked);
    }
  }, [defaultValue]);

  const inputClass = [
    className,
    valid === false ? 'is-invalid' : '',
  ].join(' ');

  return (
    <>
      <IMaskInput
        mask="000.000.000-00"
        value={value}
        onAccept={handleAccept}
        unmask={false}
        className={inputClass}
        name={id}
        id={id}
        required={required}
        placeholder={placeholder}
        disabled={disabled}
      />
      {valid === false && (
        <div className="invalid-feedback">CPF inválido</div>
      )}
    </>
  );
};

export default CpfInput;
